const Modal = props => {
    const structure = props.structure

    if (structure.scroll && structure.display === true) {
        document.body.classList.add('modal-active')
    } else {
        document.body.classList.remove('modal-active')
    }

    return <div className={`modal ${structure.display && 'active'} ${structure.cssClass && structure.cssClass} ${structure.scroll && 'scroll'}`}>
        <div className="content">
            <div className="header">
                <div dangerouslySetInnerHTML={{ __html: structure.header }}></div>
                <div className="close" onClick={props.onToggle}>×</div>
            </div>
            <div className="body">{props.children}</div>
            {structure.footer && <div className="footer" dangerouslySetInnerHTML={{ __html: structure.footer }}></div>}
        </div>
    </div>

}

export default Modal